import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolRoleMid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1088_5799)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_1088_5799)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M3.33642 9.60127V3.34373H9.45757L12.2393 0.5H0.5V12.5009L3.33642 9.60127Z",
					fill: "currentColor",
					fillOpacity: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.6231 6.61446V12.6563H6.71409L3.93125 15.5H15.4595V3.71484L12.6231 6.61446Z",
					fill: "currentColor",
					fillOpacity: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5 2.77364V0.52124H13.0518L0.556859 13.2957V15.4933H2.82359L15.5 2.77364Z",
					fill: "currentColor"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1088_5799",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(0.5 0.5)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_1088_5799",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(0.5 0.5)"
		})
	})] })]
});
export default SvgLolRoleMid;
